export default class EitherOrStatsModel {
  public eitherOrId: string = "";
  public personalBest: number = 0;
  public betterThan: number = 0;
}
